import React from 'react';
import NavBar from '../components/NavBar';

const Dashboard = () => {
  return (
    <div className="dashboard-container">
      <NavBar/>

      <div>
        <h1>Dashboard Page</h1>
        <h2>Em manutenção...</h2>
      </div>
    </div>
    
  )
};

export default Dashboard;